import { RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { UserRoleEnum } from '~enums';
import WikiPage from '~features/wiki/wikiPage';
import WikiLayout from '~layouts/wiki/wikiLayout';

import ProtectedRoute from './components/protectedRoute';

const WikiRoutes = (): RouteObject[] => {
	const allowedRoles = [UserRoleEnum.SuperAdmin, UserRoleEnum.ClientAdmin, UserRoleEnum.Support];

	return [
		{
			element: <ProtectedRoute allowedRoles={allowedRoles} />,
			children: [
				{
					path: pagePathSegments.Wiki,
					element: <WikiLayout />,
					children: [
						{
							path: ':id?',
							element: <WikiPage />,
						},
					],
				},
			],
		},
	];
};

export default WikiRoutes;
